// extracted by mini-css-extract-plugin
module.exports = {"sale__wrapper":"styles_sale__wrapper__pHL6y","sale__content":"styles_sale__content__96Gx6","clickEffect":"styles_clickEffect__pNcKN","pulse":"styles_pulse__40WUu"};